import flatten from "lodash/flatten";
import uniqBy from "lodash/uniqBy";
import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useProfileSkillsFrameworks } from "PFCore/hooks/queries/skills_frameworks/use_profile_skills_frameworks";
import { FeatureFlag, Id } from "PFTypes";

type UseProfileSuggestedSkills = {
  profileId: Id;
  enabled?: boolean;
};

export const useProfileSuggestedSkills = ({ profileId, enabled = true }: UseProfileSuggestedSkills) => {
  const isSkillsFrameworksEnabled = useIsFeatureEnabled(FeatureFlag.SkillsFramework);

  const { data, isFetching } = useProfileSkillsFrameworks({
    profileId,
    params: { page: 1, perPage: PER_PAGE_UNPAGINATED },
    options: {
      enabled: isSkillsFrameworksEnabled && enabled,
      select: (data) => ({
        suggestedFrameworksSkills: uniqBy(
          flatten(
            (data.entries || []).map((skillsFramework) =>
              skillsFramework.skills
                .filter(({ proposed }) => proposed)
                .map(({ skillId, value, requiredExperience, tagIds }) => ({
                  id: skillId,
                  value,
                  text: value,
                  requiredExperience,
                  tagIds
                }))
            )
          ),
          "id"
        ),
        totalSkillsFrameworks: data.meta.total
      })
    }
  });

  return {
    suggestedFrameworksSkills: data?.suggestedFrameworksSkills || [],
    totalSkillsFrameworks: data?.totalSkillsFrameworks || 0,
    isLoading: isFetching
  };
};
